export const MyStatisticsItemSeparator = () => (
  <div className="tw-h-[1px] tw-w-full tw-self-stretch tw-bg-[#3090DC] lg:tw-h-auto lg:tw-w-[1px]" />
)
